import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    DispatchCompleteLoadProducts,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { getCurrencyCode, trackGA4ViewItemList } from "@thkStore/Common/Utilities/ga4EcommerceTracking";

const SendGA4ViewItemListEvent: typeof DispatchCompleteLoadProducts = props => {
    if (!props.result.products?.length) {
        return;
    }

    const state = props.getState();
    const currency = getCurrencyCode(state);

    const isSearch = !!props.apiParameter.search;
    const catalogPage = props.result.catalogPage;

    const listId = isSearch ? "search_results" : catalogPage?.canonicalPath || "category";
    const listName = isSearch ? "Search Results" : catalogPage?.title || "Category";

    trackGA4ViewItemList(props.result.products, listId, listName, currency);
};

addToChainAfter(chain, DispatchCompleteLoadProducts, SendGA4ViewItemListEvent);

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
